import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'mc-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  @Output() closeEvent = new EventEmitter();
}
